export const searchMixin = {
    methods: {
        setSearchResults(search) {
            this.searchResults = search;
            console.debug("call initialized again for searchresults", this.searchResults);
            this.total = this.searchResults.length;
            Vue.nextTick(() => {
                this.initialized('#search-res', '.row_tracker', false);
            });
        },
        setIds(ids) {
            this.ids = [...ids];
            this.$emit('setIds', this.ids);
        },
        setCurResults(bool) {
            this.ids = [];
            if (bool) {
                this.searchResults = [];
                // this.changeCurr(this.editCurr)
            }
        },
    }
};
